import Heading from 'components/partials/heading/heading';
import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import Loader from 'components/partials/loader/loader';

import { useInsights } from 'containers/admin/clients/client/tabs-components/insights-tab/hooks/use-insights';
import { getInsightsTableSettings } from 'containers/admin/clients/client/tabs-components/insights-tab/insights-tab-table-settings';

import Icons from 'assets/icons';

interface InsightsTabProps {
  clientId: string | number | undefined;
}

const InsightsTab = ({ clientId }: InsightsTabProps): React.JSX.Element => {
  const {
    insights,
    initialLoading,
    isLoading,
    sortingParams,
    setSortingParams,
  } = useInsights({ clientId });

  const columns = getInsightsTableSettings({
    clientId,
  });

  const renderContent = (): React.JSX.Element | null => {
    if ((!!insights.length && !isLoading) || (isLoading && !initialLoading)) {
      return (
        <TableComponent
          columns={columns}
          data={insights}
          isLoading={isLoading}
          sortingParams={sortingParams}
          setSortingParams={setSortingParams}
          pagination={false}
          customHeight="max-h-[50vh]"
        />
      );
    }

    if (!isLoading && insights.length === 0) {
      return (
        <EmptySpaceContent
          image={<Icons.EmptyImage customClass="w-[210px] h-[210px]" />}
          text="There are no insights to show yet."
        />
      );
    }

    return null;
  };

  return (
    <div className="relative">
      <Loader
        loading={initialLoading}
        customClass="!bg-white"
        fullScreen={false}
      />

      <div className="flex justify-between items-center my-5">
        <Heading variant="h2">Insights</Heading>
      </div>

      <div className="relative">{renderContent()}</div>
    </div>
  );
};

export default InsightsTab;
